import React, { createContext, useState, useContext, useCallback } from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'https://agent-ia-senegal.onrender.com'
const LangContext = createContext()

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'fr')

  const changeLang = useCallback(async (code) => {
    setLang(code)
    localStorage.setItem('lang', code)
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user?.phone) {
      try {
        await axios.put(`${API_URL}/api/auth/language`, { phone: user.phone, language: code })
        console.log(`🌍 Langue sauvegardée: ${code}`)
      } catch (e) { console.error('Erreur langue:', e.message) }
    }
  }, [])

  const loadLangFromAccount = useCallback(async (phone) => {
    try {
      const res = await axios.get(`${API_URL}/api/auth/profile/${encodeURIComponent(phone)}`)
      if (res.data.language) {
        setLang(res.data.language)
        localStorage.setItem('lang', res.data.language)
        console.log(`🌍 Langue compte: ${res.data.language}`)
      }
    } catch (e) { console.error('Erreur chargement langue:', e.message) }
  }, [])

  return (
    <LangContext.Provider value={{ lang, changeLang, loadLangFromAccount }}>
      {children}
    </LangContext.Provider>
  )
}

export const useLang = () => useContext(LangContext)
